// Aspect-preserving canvas resize shared by every photo/avatar upload path.
// `source` is a File/Blob or an image URL / data-URL string. Scales to fit `max`
// on the longest edge (never upscales) and returns a JPEG data URL, or null on a
// load/draw failure so callers can fall back.
export function canvasResize(source, { max, quality }) {
  return new Promise((resolve) => {
    const img = new Image()
    const objectUrl = typeof source === "string" ? null : URL.createObjectURL(source)

    img.onload = () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl)
      try {
        let w = img.width
        let h = img.height
        if (w > h) {
          if (w > max) { h = Math.round(h * max / w); w = max }
        } else {
          if (h > max) { w = Math.round(w * max / h); h = max }
        }
        const canvas = document.createElement("canvas")
        canvas.width = w
        canvas.height = h
        canvas.getContext("2d").drawImage(img, 0, 0, w, h)
        resolve(canvas.toDataURL("image/jpeg", quality))
      } catch (e) {
        resolve(null)
      }
    }
    img.onerror = () => { if (objectUrl) URL.revokeObjectURL(objectUrl); resolve(null) }
    img.src = objectUrl || source
  })
}

// Single source of truth for the photo thumbnail that feeds the
// library_photos.thumbnail column (the match / discovery / session-card mosaic
// UI). Previously each upload path picked its own size (200/400/600/1200) — drift.
export const PHOTO_THUMBNAIL = { max: 1200, quality: 0.8 }

// Tiny, low-quality stand-in served to the OTHER person until the photo's owner
// approves it. At ~24px it's unrecognizable (just vague colors) — safe to send,
// and the client scales + CSS-blurs it into a soft placeholder.
export const BLUR_PLACEHOLDER = { max: 24, quality: 0.4 }
